import { render, staticRenderFns } from "./SelectedTotalPanel.vue?vue&type=template&id=f0a40968&scoped=true&"
import script from "./SelectedTotalPanel.vue?vue&type=script&lang=ts&"
export * from "./SelectedTotalPanel.vue?vue&type=script&lang=ts&"
import style0 from "./SelectedTotalPanel.vue?vue&type=style&index=0&id=f0a40968&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a40968",
  null
  
)

export default component.exports